import Link from "next/link";
import React, { useState } from "react";

import { StepProp } from "./Step1";
import { useResetPaswordMutation } from "@/graphql/generated/schema";
import toast from "react-hot-toast";
import { useRouter } from "next/navigation";
import Button from "@/designs/Button";

const Step3 = ({ setSteps, email }: StepProp) => {
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [resetPswd, { loading }] = useResetPaswordMutation();
  const router = useRouter();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!password || !verifyPassword) {
      toast.error("Please enter and confirm your new password.");
      return;
    }

    if (password !== verifyPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const { data } = await resetPswd({
        variables: { email, password },
      });

      const output = data?.resetPasword;

      if (output?.user?.id) {
        toast.success("Password reset successful. You can now log in.");
        setSteps(); // go to login or success step
        router.push("/login");
      } else {
        toast.error(output?.error?.message || "Failed to reset password.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <form className="space-y-5" onSubmit={handleSubmit}>
      <div>
        <label className="block text-sm font-medium  mb-1">
          New Password
        </label>
        <input
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#004175]"
        />
      </div>

      <div>
        <label className="block text-sm font-medium  mb-1">
          Confirm Password
        </label>
        <input
          type="password"
          placeholder="••••••••"
          value={verifyPassword}
          onChange={(e) => setVerifyPassword(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#004175]"
        />
      </div>

      <div className="text-right text-sm">
        <Link href="/login" className="text-[#004175] hover:underline">
          Back to login
        </Link>
      </div>

      <Button type="submit" loading={loading}>
        Reset Password
      </Button>
    </form>
  );
};

export default Step3;
